import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { topNavStyle } from "../components/nav/topNavStyle";
import BrandWordmark from "../components/BrandWordmark";

const steps = [
  {
    n: '1',
    title: 'Join or create a league',
    body: 'Start by creating a private league or joining one with a friend\'s invite code. Play with people you know.',
  },
  {
    n: '2',
    title: 'Draft your teams',
    body: 'Take turns picking college teams in a live snake draft. You\'ll end up with 5 starters and 2 bench teams. Choose wisely.',
  },
  {
    n: '3',
    title: 'Earn points weekly',
    body: 'Your teams earn points based on their real-life game results every Saturday. Win when they win, lose when they lose.',
  },
  {
    n: '4',
    title: 'Manage your lineup',
    body: 'Swap starters with bench teams, pick up free agents, and drop underperformers throughout the season.',
  },
  {
    n: '5',
    title: 'Climb the standings',
    body: 'The manager with the most points at the end of the season wins.',
  },
];

function HowToPlay() {
  return (
    <div className="theme-auto" style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg-card)', display: 'flex', flexDirection: 'column' }}>

      {/* Nav */}
      <nav style={topNavStyle({ paddingX: 16, paddingY: 16 })}>
        <Link to="/">
          <BrandWordmark width="clamp(96px, 24vw, 160px)" />
        </Link>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="/login" style={{ fontSize: 14, fontWeight: 500, color: 'var(--color-text-muted)', textDecoration: 'none', whiteSpace: 'nowrap' }}>
            Log in
          </Link>
          <Link
            to="/signup"
            style={{
              fontSize: 14, fontWeight: 700, color: 'var(--color-cta-text)',
              padding: '8px 14px', borderRadius: 50, textDecoration: 'none',
              backgroundColor: 'var(--color-cta)',
              whiteSpace: 'nowrap',
            }}
          >
            Sign up free
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '20px 24px 64px', flex: 1 }}>

        {/* The page is five screens of scrolling, and the only way back was at
            the very bottom. Anyone who read a step or two and changed their
            mind had to scroll past the rest to leave. */}
        <Link
          to="/"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            minHeight: 44, fontSize: 14, fontWeight: 600,
            color: 'var(--color-cta)', textDecoration: 'none',
          }}
        >
          <ArrowLeft size={16} strokeWidth={2.2} /> Back
        </Link>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontSize: 28, fontWeight: 900, color: 'var(--color-text-strong)', margin: '0 0 8px' }}>
            How it works
          </h1>
          <p style={{ fontSize: 16, color: 'var(--color-text-muted)', margin: 0 }}>
            College football fantasy in five simple steps.
          </p>
        </div>

        {/* Steps */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {steps.map(({ n, title, body }) => (
            <div
              key={n}
              style={{
                display: 'flex', gap: 16, alignItems: 'flex-start',
                backgroundColor: 'var(--color-bg-page)', borderRadius: 16, padding: '20px 20px',
                border: '1px solid var(--color-bg-subtle)',
              }}
            >
              <div style={{
                width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                backgroundColor: 'var(--color-cta)', color: 'var(--color-cta-text)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 800, fontSize: 16,
              }}>
                {n}
              </div>
              <div>
                <div style={{ fontWeight: 700, color: 'var(--color-text-strong)', fontSize: 16, marginBottom: 4 }}>{title}</div>
                <p style={{ fontSize: 14, color: 'var(--color-text-muted)', margin: 0, lineHeight: 1.6 }}>{body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: 40 }}>
          <Link
            to="/signup"
            style={{
              display: 'inline-block', padding: '16px 40px', borderRadius: 50,
              backgroundColor: 'var(--color-cta)', color: 'var(--color-cta-text)', fontWeight: 700,
              fontSize: 16, textDecoration: 'none',
            }}
          >
            Get started for free
          </Link>
          <div style={{ marginTop: 16 }}>
            <Link to="/" style={{ fontSize: 14, color: 'var(--color-text-faint)', textDecoration: 'none' }}>
              ← Back
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowToPlay;
